module.exports = __webpack_public_path__ + "img/9788933706275.d8f66ed1.jpg";